import {OriginalProductFormat, ProductAnalyticsFormat} from "~/helpers/analytics/types";

export function adaptProduct(product: OriginalProductFormat, component = ''): ProductAnalyticsFormat {
  return {
    item_name: product.name || `this item does not exist ${component}`,
    item_id: product.id || `this item does not exist ${component}`,
    price: product.regularPrice || 0,
    discount: Math.round((product.regularPrice - product.specialPrice) * 100) / 100 ?? null,
    collection: product.collection || `this item does not exist ${component}`,
    item_category: product.category?.[0] || `this item does not exist ${component}`,
    item_category2: product.category?.[1] || `this item does not exist ${component}`,
    item_brand: product.brand || `this item does not exist ${component}`,
    item_variant: product.variant || `this item does not exist ${component}`,
    product_url: product.link || `this item does not exist ${component}`,
  };
}
